export class NoticeModel {
    constructor(public existing: ScheduledItem | undefined) {
        let currentDate = new Date();
        if (existing?.header != undefined) {
            this.headline = existing.header;
            this.body = existing.message;
            this.agency = existing.recipients?.oris;
            this.condition = existing.type.toString();
            this.emailRecipients = existing.recipients?.type;

            let targetDate = existing.next_run;
            targetDate = targetDate.replace("9999-12-31","");
            targetDate = targetDate.replace("0001-01-01","");
            
            if(targetDate == undefined || targetDate == ""){
                targetDate = currentDate.toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
            }
            
            this.scheduleNotification = new Date(targetDate);
            this.repeat = existing.schedule.type ?? NotificationScheduleType.OneTime;
        } else {
            this.headline = "";
            this.body = "";
            this.agency = [] as string[];
            this.condition = "";
            this.emailRecipients = [NotificationEmailType.None];
            this.scheduleNotification = currentDate;
            this.repeat = NotificationScheduleType.OneTime;
        }
    }
    headline: string;
    body: string;
    agency: string[] | undefined;
    condition: string | undefined;
    emailRecipients: NotificationEmailType[];
    // Getter for emailRecipients
    get emailRecipientsArray(): NotificationEmailType[] {
        if(this.emailRecipients == undefined){
            this.emailRecipients = [NotificationEmailType.None];
        }

        return this.emailRecipients;
    }
    
    // Setter for emailRecipients
    set emailRecipientsArray(newEmailRecipients:NotificationEmailType[]) {
        if(newEmailRecipients == this.emailRecipients || (Array.isArray(newEmailRecipients) && Array.isArray(this.emailRecipients) && areNumberArraysEqualUnordered(newEmailRecipients, this.emailRecipients))){
            return;
        }
        
        let isNaSelected = false;
        let onlyTheNewItems = newEmailRecipients.filter(
            (value: NotificationEmailType) => this.emailRecipients?.indexOf(value) === -1
        );

        if (onlyTheNewItems?.length > 0) {
            onlyTheNewItems.forEach((item: NotificationEmailType) => {
                if (item == NotificationEmailType.None) {
                    isNaSelected = true;
                }
            });

            // If N/A was part of the new selections made by the user then we only set n/a
            // If N/A wasn't just selected then we make sure it's not one of the existing selections
            let newValues = isNaSelected
                ? [NotificationEmailType.None]
                : newEmailRecipients.filter((value) => value != NotificationEmailType.None);

                this.emailRecipients = newValues;
        } else {
            this.emailRecipients = newEmailRecipients;
            if (this.emailRecipients.length == 0) {
                this.emailRecipients = [NotificationEmailType.None];
            }
        }
    }

    scheduleNotification: Date | undefined;
    repeat: NotificationScheduleType;
}

function areNumberArraysEqualUnordered(arr1: number[], arr2: number[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }
  
    const sortedArr1 = [...arr1].sort((a, b) => a - b); // Create copies to avoid modifying original arrays
    const sortedArr2 = [...arr2].sort((a, b) => a - b);
  
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }
    return true;
  }
  

export interface NoticeItem {
    id: number;
    task_id: number;
    run_date: Date;
    success: boolean;
    message: string;
    description: string;
    sent_notices: number;
    sent_emails: number;
    failed_emails: number;
    sent_notices_filtered: number;
    agency_list: string;
    is_dismissed: boolean;
    ori: string;
    email:string;
}

export interface ScheduledItem {
    id: number;
    description: string;
    type: NotificationTaskType;
    header: string;
    message: string;
    recipients: NoticeRecipient;
    condition: string;
    schedule: NotificationSchedule;
    created_on: string;
    created_by: string;
    first_run: string;
    last_run: string;
    next_run: string;
}

export enum NotificationTaskType {
    Announcement = 1,
    NoNibrsSubmissionsMonth = 100,
    NoNibrsSubmissionsDays = 101,
    OutstandingErrors = 102,
    OutstandingWarnings = 103,
    NoUofSubmissionsMonth = 200,
    NoUofSubmissionsDays = 201,
    MissingEmployeeData = 300,
}
export interface NoticeRecipient {
    oris: string[];
    type: NotificationEmailType[];
    is_displayed: boolean;
}

export enum NotificationEmailType {
    None = 0,
    EmailAgencyAdministrator = 1,
    EmailProgramManager = 2,
    EmailCommander = 3,
}

export interface NoticeDetails {
    date: Date;
    headline: string;
    body: string;
    recipients: NoticeRecipient[];
}

export interface NotificationSchedule {
    type: NotificationScheduleType;
    year: Number;
    month: Number;
    weekday: Number;
    date: Number;
    hour: Number;
    minute: Number;
}

export enum NotificationScheduleType {
    OneTime = 0,
    Daily = 1,
    Weekly = 7,
    DayOfMonth = 30,
}
